import { type TFunction } from '!/i18n'
import type { ShowWithPrice, UiCategoryWithShows } from '@/interfaces'
import { extendMediaItemByLabelPrice } from '@/tools'
import type { CategoryWithShows } from '@setplex/tria-api'
import { type AdjustPurchaseableFn } from '~/features/payment/sse-purchases'
import {
  type CurrentTvShowWithPriceFormatted,
  type FormatCurrentShowParams,
} from './index.h'

export const formatCategoryWithShowsToUi = (
  data: CategoryWithShows | null,
  adjust: AdjustPurchaseableFn,
  t: TFunction
): UiCategoryWithShows | null => {
  if (!data) return null

  const formattedContent = data.content.map((tvShow) =>
    extendMediaItemByLabelPrice(adjust(tvShow))
  ) as ShowWithPrice[]

  const name = data.id === 0 ? t('all') : data.name

  return {
    ...data,
    name,
    content: formattedContent,
  }
}

export const formatCurrentShow = ({
  current,
  adjust,
  t,
}: FormatCurrentShowParams): CurrentTvShowWithPriceFormatted | null => {
  if (!current) return null
  const count = current.episodeCount || 0

  return {
    ...(extendMediaItemByLabelPrice(adjust(current)) as ShowWithPrice),
    currentEpisodesCount: t('episode_count', { count }),
  }
}
